/** The little celebrations on the planet: a tile bounces, sparks fly from a tile. */
import type { Loop } from '@core/loop';
import { SPARK_BUILD } from '@core/palette';

import type { Display } from '../planet/display';
import type { Planet } from '../planet/planet';
import type { Props } from '../props';
import type { Sparks } from '../stage/sparks';

export interface Effects {
  /** A tile bounces: its block and whatever stands on it. */
  pop: (tile: number, now: number) => void;
  /** Sparks out of a tile, in `color` (hex). */
  burst: (tile: number, color: number, count: number) => void;
  /** Sparks all over the planet: it grew. */
  celebrate: (bursts?: number) => void;
}

export function createEffects(
  planet: Planet,
  props: Props,
  sparks: Sparks,
  display: Display,
  loop: Loop,
): Effects {
  const burst = (tile: number, color: number, count: number): void => {
    if (!display.grid) return;
    sparks.burst(display.grid, tile, display.shownRadius, planet.tileTop(tile), color, count);
    loop.wake(1500);
  };
  return {
    pop: (tile, now) => {
      planet.pop(tile, now);
      props.pop(tile, now);
      loop.wake(800);
    },
    burst,
    celebrate: (bursts = 24) => {
      const grid = display.grid;
      if (!grid) return;
      for (let i = 0; i < bursts; i++)
        burst(Math.floor(Math.random() * grid.count), SPARK_BUILD, 8);
    },
  };
}
